import React from 'react';
import PredictionFormTemplate from 'components/templates/PredictionFormTemplate/PredictionFormTemplate';
import PredictionForm from 'components/organisms/PredictionForm/PredictionForm';

function Prediction() {
  return <PredictionFormTemplate formSection={<PredictionForm />} />;
}

export default Prediction;
